import checkAccess from 'utils/roles/checkAccess';
import getFranchiseRegion from 'utils/jwt/getFranchiseRegion';

export const routerPath = {
  root: '/corporate',
};

export const getColumns = ({ editItem }) => [
  {
    id: 'mediaId',
    type: 'avatar',
    label: 'Avatar',
    align: 'center',
    disableSort: 'true',
  },
  { id: 'name', label: 'Corporate', align: 'center' },
  { id: 'active', label: 'Status', customValue: (val) => (val.active ? 'Active' : 'Inactive'), align: 'center' },
  { id: 'code', label: 'Corp Code', align: 'center', disableSort: true },
  { id: 'region', label: 'Region', align: 'center', nameForSort: 'region' },
  { id: 'subscriptionType', label: 'Subscription Type', align: 'center', nameForSort: 'subscription_type' },
  {
    id: 'subscriptionCost',
    label: 'Subscription Cost',
    customValue: (val) => val.subscriptionCost || '',
    align: 'center',
    disableSort: true,
  },
  {
    id: 'more-menu',
    type: 'menu',
    items: [{ id: 1, name: 'Edit', action: editItem, icon: 'eva:edit-fill' }],
    disableSort: true,
  },
];

export const getFilters = ({ searchBy, active, region, options }) => [
  {
    id: 'name',
    type: 'search',
    placeholder: 'Corporate name',
    action: searchBy.change,
  },
  {
    id: 'regions',
    type: 'select',
    label: 'Region',
    value: checkAccess([2]) ? getFranchiseRegion() : region.value,
    action: region.change,
    items: options?.regions?.length ? ['all', ...options.regions] : ['all'],
    disabledEdit: checkAccess([2]),
  },
  {
    id: 'active',
    type: 'switch',
    label: 'Active',
    value: active.value === 'true',
    action: active.change,
  },
];
